import { defineStore } from 'pinia';
import { Admin } from '@/models/admin/admin.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';

interface AdminState {
  isAdminLoading: boolean;
  admin: Admin | null;
}

export const useAdminStore = defineStore('AdminStore', {
  state: (): AdminState => ({
    isAdminLoading: false,
    admin: null,
  }),
  getters: {
    adminEmail(state: AdminState): string | undefined {
      return state.admin?.email;
    },
  },
  actions: {
    setAdminLoading(isLoading: boolean): void {
      this.isAdminLoading = isLoading;
    },
    getAdmin(): Promise<Admin | void> {
      if (this.admin) {
        return Promise.resolve(this.admin);
      }

      this.setAdminLoading(true);

      return api.admin.getAdminRequest().perform()
        .then((data: Admin) => {
          this.admin = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);
        })
        .finally(() => {
          this.setAdminLoading(false);
        });
    },
  },
});
